import { VoiceFrame } from "./voiceFrames";

export interface ChatRequest {
  traceId: string;
  requestType: string;
  voice: boolean;
}

export interface TypedTurn {
  text: string;
  traceId: string;
}

export interface MaskedRequest {
  traceId: string;
}

export interface VoiceBusListener {
  requestOpened?: (request: ChatRequest) => void;
  requestFailed?: (request: ChatRequest) => void;
  requestClosed?: (request: ChatRequest) => void;
  requestMasked?: (request: MaskedRequest) => void;
  voiceFrame?: (frame: VoiceFrame, replyKind: string | null) => void;
  typedTurn?: (turn: TypedTurn) => void;
  checkoutNote?: (text: string) => void;
}

let listener: VoiceBusListener | null = null;
let liveSessionId: string | null = null;
let activeRequest: ChatRequest | null = null;

export function voiceTurnMarks(voice: boolean): { inputMode?: "voice" | "typed"; liveSessionId?: string } {
  return liveSessionId ? { inputMode: voice ? "voice" : "typed", liveSessionId } : {};
}

export const voiceBus = {
  attach(next: VoiceBusListener): () => void {
    listener = next;
    return () => {
      if (listener === next) listener = null;
    };
  },

  setLiveSessionId(id: string | null): void {
    liveSessionId = id;
  },

  getLiveSessionId(): string | null {
    return liveSessionId;
  },

  activeRequest(): ChatRequest | null {
    return activeRequest;
  },

  requestOpened(message: any): void {
    voiceBus.requestClosed();
    activeRequest = {
      traceId: typeof message?.traceId === "string" ? message.traceId : "",
      requestType: typeof message?.requestType === "string" ? message.requestType : "",
      voice: message?.voice === true,
    };
    listener?.requestOpened?.(activeRequest);
  },

  requestFailed(turn: ChatRequest | null | undefined): void {
    if (turn) listener?.requestFailed?.(turn);
  },

  requestClosed(): void {
    const closed = activeRequest;
    activeRequest = null;
    if (closed) listener?.requestClosed?.(closed);
  },

  requestMasked(request: MaskedRequest): void {
    listener?.requestMasked?.(request);
  },

  voiceFrame(frame: VoiceFrame, replyKind: string | null): void {
    listener?.voiceFrame?.(frame, replyKind);
  },

  typedTurn(turn: TypedTurn): void {
    listener?.typedTurn?.(turn);
  },

  checkoutNote(text: string): void {
    listener?.checkoutNote?.(text);
  },
};
